module.exports = __webpack_public_path__ + "static/media/top.88e89af1.png";